import React from 'react';
import PropTypes from 'prop-types';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMConst from 'lib/SMConst';

class SMReservationEditViewNumberOfGuest extends React.Component{

  selectBoxDidChangeValue(e){
    this.props.delegate.changeNumberOfGuests(e.currentTarget.value);
  }
  
  render(){
    const room = this.props.room;
    const capacity = this.props.rentType == SMConst.RentType.Stay ? room.stay_capacity : room.capacity;

    let selectBoxItems = [];
    for (let j=0; j < capacity; j++) {
      selectBoxItems.push({value: j+1, label:j+1});
    }
    
    return(
      <td>
        <span className="form-select__inner">
          <label className="form-select">
            <SMFormSelectBox
              name='number_of_guests'
              items={selectBoxItems}
              selectedValue={this.props.reservation.number_of_guests}
              delegate={this}
              options={{className:'w60'}} />
          </label>
        </span>
      </td>
    );
  }
}

SMReservationEditViewNumberOfGuest.propTypes = {
  reservation: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  number_of_guests: PropTypes.number.isRequired,
  rentType: PropTypes.number.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewNumberOfGuest;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewNumberOfGuest.jsx